export const allRecipientsText = 'All Recipients';
export const RecipientsText = 'Recipients';
export const recipientsSearchMinSymbols = 3;
export const VALUES_FETCH_SIZE = 1000;
